import { nominees } from '../constants/ActionTypes';

const INITIAL_STATE = {
    list: [],
    selected: null
}

const positionsActionsFunc = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case nominees.GET_NOMINEES: {
            return { ...state, list: action.payload }
        }
        case nominees.GET_NOMINEE: {
            return { ...state, selected: action.payload }
        }
        default:
            return state;
    }
}

export default positionsActionsFunc